import { render, staticRenderFns } from "./SubJobStageView.vue?vue&type=template&id=68c71b2e"
import script from "./SubJobStageView.vue?vue&type=script&lang=js"
export * from "./SubJobStageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c71b2e')) {
      api.createRecord('68c71b2e', component.options)
    } else {
      api.reload('68c71b2e', component.options)
    }
    module.hot.accept("./SubJobStageView.vue?vue&type=template&id=68c71b2e", function () {
      api.rerender('68c71b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/subjobstage/SubJobStageView.vue"
export default component.exports